import * as Yup from 'yup';

//doc date should be less than or equal to current date
//transport doc date should be more than or equal to current date

export const validationSchema = (distbool) =>
  Yup.object({
    subType: Yup.string().required('Required'),
    docType: Yup.string().required('Required'),
    transType: Yup.string().required('Required'),
    ...(distbool && {
      distance: Yup.string().required('Required'),
    }),
  });
